import React, { useState } from "react";
import { TDateFormat, TOnChangeInput } from "../../data/AppType";
import { dateFormat, getLocalDate } from "../../utils/AppFunctions";
import { DATE_FORMAT } from "../../utils/AppEnumerations";
import { calendarIcon } from "../../assets/icons/SvgIconList";
import { cn } from "../../lib";
export interface ICDatePickerProps {
  useValue?: boolean;
  value?: Date;
  min?: Date;
  max?: Date;
  onChangeDate?: (event: TOnChangeInput) => void;
  placeholder?: string;
  displayFormat?: TDateFormat;
  errorMessage?: string;
  label?: string;
  required?: boolean;
  disabled?: boolean;
}
const ICDatePicker: React.FC<ICDatePickerProps> = (props) => {
  const {
    useValue,
    value,
    placeholder,
    onChangeDate,
    min,
    max,
    displayFormat,
    errorMessage,
    label,
    required,
    disabled,
  } = props;
  const [selectedDate, setSelectedDate] = useState<Date>();
  const [isFocused, setIsFocused] = useState(false);
  const handleDateChange = (event: TOnChangeInput) => {
    if (!useValue) {
      setSelectedDate(
        event.target.value ? getLocalDate(event.target.value) : undefined
      );
    }
    if (onChangeDate) {
      onChangeDate(event);
    }
  };
  const getFormattedDisplayValue = (date: Date) => {
    return dateFormat(date, displayFormat ?? DATE_FORMAT["YYYY-MM-DD"]);
  };

  const handleFocusDatePicker = () => {
    setIsFocused(true);
  };
  const handleBlurDatePicker = () => {
    setIsFocused(false);
  };
  const getDisplayValue = (
    selectedDate: Date | undefined,
    placeholder: string | undefined
  ) => {
    if (selectedDate) {
      return getFormattedDisplayValue(selectedDate);
    } else if (placeholder) {
      return <span>{""}</span>;
    } else {
      return getFormattedDisplayValue(getLocalDate());
    }
  };
  return (
    <div>
      <div
        className={cn(
          `relative flex items-center border border-muted text-muted rounded-lg appearance-none bg-transparent h-10
        hover:border-black focus-within:border-accent focus-within:text-accent`,
          { "error-border": errorMessage }
        )}
      >
        {label && (
          <label
            className={cn(`absolute flex items-center pl-2`, {
              "pointer-events-none transition-all duration-300 ease-in-out left-2 transform -translate-y-[60%] bg-subtle top-0 text-xs px-1":
                isFocused || selectedDate || value,
            })}
          >
            {label + (required ? "*" : "")}
          </label>
        )}
        <div
          className="flex justify-between items-center w-full h-6 px-2"
          onClick={(event) => event.stopPropagation()}
        >
          <div
            className={cn("custom-text-input", {
              "text-disable": disabled,
            })}
          >
            {value
              ? getFormattedDisplayValue(value)
              : getDisplayValue(selectedDate, placeholder)}
          </div>
          <div className="h-4 w-4 ">{calendarIcon}</div>
        </div>
        {!disabled && (
          <input
            min={min ? dateFormat(min, DATE_FORMAT["YYYY-MM-DD"]) : undefined}
            max={max ? dateFormat(max, DATE_FORMAT["YYYY-MM-DD"]) : undefined}
            className="ic-date-input w-full"
            type="date"
            onChange={handleDateChange}
            onFocus={handleFocusDatePicker}
            onBlur={handleBlurDatePicker}
            value={
              (selectedDate && selectedDate instanceof Date
                ? selectedDate.toISOString().split("T")[0]
                : "") ||
              (value && value instanceof Date
                ? value.toISOString().split("T")[0]
                : "")
            }
          />
        )}
      </div>
      {errorMessage && (
        <div className="text-sm text-danger">{errorMessage}</div>
      )}
    </div>
  );
};
export default ICDatePicker;
